import { useLang } from "@/i18n/LanguageContext";

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap font-sans text-xs tracking-[0.4em] text-ivory/40">
          {item}
        </span>
        <span className="mx-10 inline-block h-1.5 w-1.5 rotate-45 bg-gold/70" />
      </span>
    ))}
  </div>
);

const Marquee = () => {
  const { t } = useLang();
  return (
    <div
      className="hv-marquee overflow-hidden border-y border-gold/15 bg-midnight py-6"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="hv-marquee-track flex w-max">
        <Row items={t.marquee} />
        <Row items={t.marquee} />
      </div>
    </div>
  );
};

export default Marquee;
